import template from 'app/templates/widget.mustache'
import renderer from 'lib/renderer'
import Widget from 'app/models/widget'

export default class WidgetComponent {

  constructor(props) {
    this.renderer = props.renderer || renderer
    this.element = props.element
    this.triggerElements = props.triggerElements || []

    this.inDOM = false
    this.widget = new Widget(props, () => {
      this.render()
    })
  }

  render(callback) {
    this.renderer.render(
      template.render(this.widget.templateContext()),
      this.element
    )

    this.bindEventHandlers();
    if (!this.inDOM) {
      this.inDOM = true
      this.widget.init()
    }

    if (typeof callback === 'function') callback(this)
  }

  bindEventHandlers() {
    // Widget Trigger Click Handlers
    for (var i = 0; i < this.triggerElements.length; ++i) {
      if (this.triggerElements[i].getAttribute('data-widgetid') === this.widget.widgetId())
        this.triggerElements[i].onclick = this.triggerHandler.bind(this);
    }

    // Widget UI Click Handlers
    this.bindHandlerToClick(".tpm-button", this.widget.toggleVote);
    this.bindHandlerToClick(".tpm-upload-cta", this.widget.toggleModal);
    this.bindHandlerToClick(".tpm-modal-background", this.widget.toggleModal);
  }

  triggerHandler(event) {
    event.preventDefault();
    this.widget.toggleModal();
  }

  bindHandlerToClick(selector, handler) {
    const boundElement = this.element.querySelector(selector);
    if (boundElement) boundElement.onclick = function(event) {
      event.preventDefault();
      handler.call(this.widget, event);
    }.bind(this);
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/widget_component.js
 **/